// src/components/Dashboard/AdminDashboard/AdminFooter.js
import React from 'react';

const AdminFooter = () => {
  return (
    <footer style={{ background: 'black', color: 'yellow', padding: '1rem', textAlign: 'center' }}>
      <p>&copy; 2025 Virtual Scouting Network. All rights reserved.</p>
    </footer>
  );
};

export default AdminFooter;
